export default __webpack_public_path__ + "static/media/inspi3.ebbc7b8e.jpg";